<header class="section-header">
  <h2>کیفیت و پوشش داده</h2>
  <span>میزان دسترسی به اطلاعات</span>
</header>

<div class="coverage-metric" *ngFor="let metric of metrics">
  <div class="coverage-line">
    <span>{{ metric.label }}</span>
    <b dir="ltr">{{ metric.days ?? '—' }} / {{ totalDays ?? '—' }}</b>
  </div>
  <div class="coverage-track" [attr.role]="metric.percentage === null ? null : 'progressbar'"
    [attr.aria-label]="metric.label" [attr.aria-valuenow]="metric.percentage === null ? null : metric.days"
    [attr.aria-valuemin]="metric.percentage === null ? null : 0"
    [attr.aria-valuemax]="metric.percentage === null ? null : totalDays">
    <div class="coverage-fill" [style.width.%]="metric.percentage ?? 0"></div>
  </div>
</div>

<p class="callout">{{ message }}</p>
